import type { SettingsModalType } from '@/stores/settingsModal/types';
import { useSettingsModalStore } from '@/stores/settingsModal';
import { SettingsModalSource, SettingsTab } from '@/stores/settingsModal/types';

interface OpenSettingsModalOptions {
  type?: SettingsModalType;
  initialTab: SettingsTab;
  source: SettingsModalSource;
}

export function openSettingsModal(options: OpenSettingsModalOptions) {
  const { type = 'global', initialTab, source } = options;
  useSettingsModalStore.setState({
    visible: true,
    activeTab: initialTab,
    type,
    source,
  });
}

export function closeSettingsModal() {
  useSettingsModalStore.setState({ visible: false });
}

export { SettingsModalSource, SettingsTab };
export type { SettingsModalType };
